'use client'

import * as React from 'react'
import { ChevronDownIcon } from 'primitives/icons'
import * as Accordion from 'primitives/accordion'

const accordionDownIcon = (
  <ChevronDownIcon
    className="h-[16px] w-[16px] text-gray-500 transition-transform group-data-[state='open']/trigger:rotate-180"
    aria-hidden
  />
)

export function FilterAccordion({
  children,
  header,
  expanded,
}: PropsWithChildren<{
  header: string
  expanded?: boolean
}>) {
  const [isExpanded, setIsExpanded] = React.useState(expanded ? header : undefined)

  React.useEffect(() => {
    if (typeof window !== 'undefined' && window.innerWidth > 768 && expanded === undefined) {
      setIsExpanded(header)
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Accordion.Root
      type="single"
      collapsible
      value={isExpanded}
      onValueChange={newVal => setIsExpanded(newVal)}
    >
      <Accordion.Item value={header}>
        <Accordion.Header>
          <Accordion.Trigger
            className="flex items-center justify-between hover:cursor-pointer"
            icon={accordionDownIcon}
          >
            <span className="text-14 font-bold">{header}</span>
          </Accordion.Trigger>
        </Accordion.Header>
        <Accordion.Content>{children}</Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  )
}
